import { useBrandSlogan } from "@/lib/brandSlogan";

/**
 * Logo "Savoir Utile" — gold emblem with stylized open book + wreath.
 * onDark: when used over a dark background, brighten outer ring.
 */
export default function Logo({ size = 44, withText = true, onDark = false, textClassName = "" }) {
    const subtitle = useBrandSlogan();
    const ringStroke = onDark ? "url(#sl-gold-bright)" : "url(#sl-gold)";
    return (
        <div className="flex items-center gap-3" data-testid="logo">
            <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-label="Savoir Utile logo">
                <defs>
                    <linearGradient id="sl-gold" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#F2DDA4" />
                        <stop offset="55%" stopColor="#C9A458" />
                        <stop offset="100%" stopColor="#8C6B33" />
                    </linearGradient>
                    <linearGradient id="sl-gold-bright" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#F8E6B0" />
                        <stop offset="55%" stopColor="#E5C679" />
                        <stop offset="100%" stopColor="#B8945C" />
                    </linearGradient>
                </defs>
                {/* outer ring */}
                <circle cx="32" cy="32" r="29" stroke={ringStroke} strokeWidth="1.2" fill="none" />
                {/* inner ornamental ring */}
                <circle cx="32" cy="32" r="24" stroke={ringStroke} strokeWidth="0.6" fill="none" opacity="0.55" />
                {/* upper wreath leaves */}
                <path d="M16 22 Q24 14 32 14 Q40 14 48 22" stroke={ringStroke} strokeWidth="1.4" fill="none" strokeLinecap="round" />
                <path d="M14 26 Q22 18 30 18" stroke={ringStroke} strokeWidth="0.8" fill="none" strokeLinecap="round" opacity="0.65" />
                <path d="M50 26 Q42 18 34 18" stroke={ringStroke} strokeWidth="0.8" fill="none" strokeLinecap="round" opacity="0.65" />
                {/* book base */}
                <path d="M20 38 L32 32 L44 38 L44 46 L32 52 L20 46 Z" fill={ringStroke} opacity="0.92" />
                {/* book center fold */}
                <path d="M32 32 L32 52" stroke={onDark ? "#0B0F1A" : "#FBF7EE"} strokeWidth="1" />
                {/* small star above */}
                <path d="M32 8 L33 11 L36 11.5 L33.5 13.5 L34.2 16.5 L32 14.8 L29.8 16.5 L30.5 13.5 L28 11.5 L31 11 Z" fill={ringStroke} />
            </svg>

            {withText && (
                <div className={`leading-none ${textClassName}`}>
                    <div className="font-display text-[28px] font-semibold tracking-tight gold-text logo-shine whitespace-nowrap" data-testid="logo-title">
                        Savoir Utile
                    </div>
                    {subtitle && (
                        <div
                            className="mt-1.5 text-[9px] font-semibold tracking-[0.24em] whitespace-nowrap uppercase" data-testid="logo-slogan"
                            style={{ color: onDark ? "rgba(229, 198, 121, 0.75)" : "var(--gold-500)" }}
                        >
                            {subtitle}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
